import React from "react";

export default function LinkList({ title, children }) {
  return (
    <div>
      {title}
      <ul className="uk-list uk-margin-remove-top ">{children}</ul>
    </div>
  );
}
